import { render, staticRenderFns } from "./AddBundle.vue?vue&type=template&id=11c3481c&scoped=true"
import script from "./AddBundle.vue?vue&type=script&lang=js"
export * from "./AddBundle.vue?vue&type=script&lang=js"
import style0 from "./AddBundle.vue?vue&type=style&index=0&id=11c3481c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3481c",
  null
  
)

export default component.exports